function NXDashboard({ className }: { className?: string }) {
  return (
    <svg
    className={className}
      width="23"
      height="24"
      viewBox="0 0 23 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
    >
      <g clipPath="url(#clip0_4296_1727)">
        <path
          d="M14.3372 10.9256H8.66111C7.75378 10.9256 7.01825 11.6612 7.01825 12.5685V16.6033C7.01825 17.5107 7.75378 18.2462 8.66111 18.2462H14.3372C15.2445 18.2462 15.98 17.5107 15.98 16.6033V12.5685C15.98 11.6612 15.2445 10.9256 14.3372 10.9256Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.43958 10.9262V9.98578C9.43958 9.07845 10.1751 8.34293 11.0824 8.34293H11.9203C12.8276 8.34293 13.5631 9.07845 13.5631 9.98578V10.9262"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.1786 11.9015C22.1802 11.6734 22.1342 11.4476 22.0437 11.2383C21.9532 11.029 21.8201 10.8408 21.6528 10.6858L11.5 1.32147L1.34716 10.6858C1.17996 10.8408 1.04687 11.029 0.95636 11.2383C0.86585 11.4476 0.819906 11.6734 0.821449 11.9015V21.0358C0.821449 21.4714 0.994535 21.8894 1.30263 22.1974C1.61072 22.5055 2.0286 22.6786 2.4643 22.6786H20.5357C20.9714 22.6786 21.3893 22.5055 21.6974 22.1974C22.0056 21.8894 22.1786 21.4714 22.1786 21.0358V11.9015Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4296_1727">
          <rect
            width="23"
            height="23"
            fill="white"
            transform="translate(0 0.500031)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default NXDashboard;
